module.exports = __webpack_public_path__ + "media/images/low_rise_building-b0e6de24d3d57c7b201149bbce5b2192.png";